<!-- 设备参数设置 -->
<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-table stripe size="small" :data="records" :border="true" v-loading="loading" height="60vh">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="paramName" label="参数名称" width="200"></el-table-column>
<!--      <el-table-column prop="address" label="寄存器地址" width="100" align="center"></el-table-column>-->
      <el-table-column prop="unit" label="单位" align="center" width="60"></el-table-column>
      <el-table-column prop="paramValue" label="参数值" align="center" width="180" v-slot="{row}">
        <el-switch v-model="row.paramValue" :active-value="1" :inactive-value="0" v-if="row.type==='bit'"></el-switch>
        <el-input-number v-model="row.paramValue" :min="row.min" :max="row.max" style="width:130px" v-else></el-input-number>
      </el-table-column>
      <el-table-column prop="remark" label="参数说明" min-width="200"></el-table-column>
      <el-table-column prop="action" label="操作" width="90" align="center" fixed="right" v-slot="{row}">
        <el-button type="text" title="设置参数" @click="setParam(row.address, row.paramValue)">设置</el-button>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button type="default" @click="close">取消</el-button>
      <el-button type="primary" @click="readParams">读取参数</el-button>
<!--      <el-button type="primary" @click="setParams">写入参数</el-button>-->
    </template>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  extends: BaseVue,
  props: {
    deviceCode: {
      required: true
    }
  },
  data() {
    return {
      socket: null,
      records: [{
        address: 92,
        type: 'bit',
        paramName: "新风空调联动模式",
        paramValue: 1,
        unit: "/",
        remark: "默认模式，由系统控制空调或新风的运行"
      },{
        address: 28,
        type: 'bit',
        paramName: "空调独立运行模式",
        paramValue: undefined,
        unit: "/",
        remark: "单空调模式下（1开/0关），新风关闭，强制开启空调"
      },{
        address: 91,
        type: 'bit',
        paramName: "新风独立运行模式",
        paramValue: undefined,
        unit: "/",
        remark: "单新风模式下（1开/0关），空调关闭，强制开启新风"
      },{
        address: 93,
        type: 'bit',
        paramName: "节能计量模式",
        paramValue: undefined,
        unit: "/",
        remark: "开启节电率统计模式"
      },{
        address: 4,
        paramName: "新风启动室内温度上限",
        paramValue: undefined,
        unit: "℃",
        min: -40,
        max: 100,
        remark: "当室内温度大于该值时，启动新风系统"
      },{
        address: 5,
        paramName: "新风停止室内温度下限",
        paramValue: undefined,
        unit: "℃",
        min: -40,
        max: 100,
        remark: "当室内温度小于该值时，停止新风系统"
      },{
        address: 6,
        paramName: "空调启动室内温度上限",
        paramValue: undefined,
        unit: "℃",
        min: -40,
        max: 100,
        remark: "当室内温度大于该值时，启动空调，停止新风系统。否则停止空调，启动新风。"
      },{
        address: 7,
        paramName: "高温告警伐值",
        paramValue: undefined,
        unit: "℃",
        min: -40,
        max: 100,
        remark: "当室内温度达到该值时，启动空调和新风，并告警"
      },{
        address: 8,
        paramName: "空调启动室外温度上限",
        paramValue: undefined,
        unit: "℃",
        min: -40,
        max: 100,
        remark: "当室外温度大于该值时，停止新风系统，启动空调"
      },{
        address: 9,
        paramName: "新风停止室外温度下限",
        paramValue: undefined,
        unit: "℃",
        min: -40,
        max: 100,
        remark: "当室外温度小于该值时，停止新风系统"
      },{
        address: 27,
        paramName: "保持空调运行室外温度上限",
        paramValue: undefined,
        unit: "℃",
        min: -40,
        max: 100,
        remark: "当室外温度大于该值时，停止新风系统，保持空调一直运行"
      },{
        address: 10,
        paramName: "新风启动室内湿度上限",
        paramValue: undefined,
        unit: "%",
        min: 1,
        max: 100,
        remark: "当室内湿度大于该值时，启动新风系统"
      },{
        address: 11,
        paramName: "PM2.5",
        paramValue: undefined,
        unit: "%",
        min: 1,
        max: 500,
        remark: "当室外PM2.5大于PM(μg/m³)时，停止新风系统"
      },{
        address: 12,
        paramName: "新风启动延迟时间",
        paramValue: undefined,
        unit: "分钟",
        min: 1,
        max: 100,
        remark: "新风启动延迟时间"
      },{
        address: 13,
        paramName: "新风关闭延迟时间",
        paramValue: undefined,
        unit: "分钟",
        min: 1,
        max: 100,
        remark: "新风关闭延迟时间"
      },{
        address: 14,
        paramName: "空调启动延迟时间",
        paramValue: undefined,
        unit: "分钟",
        min: 1,
        max: 100,
        remark: "空调启动延迟时间"
      },{
        address: 15,
        paramName: "空调关闭延迟时间",
        paramValue: undefined,
        unit: "分钟",
        min: 1,
        max: 100,
        remark: "空调关闭延迟时间"
      },{
        address: 16,
        paramName: "无纺布驱动时间",
        paramValue: undefined,
        unit: "秒",
        min: 1,
        max: 100,
        remark: "每次更换无纺布电机转动时间"
      },{
        address: 17,
        paramName: "无纺布更换间隔时间",
        paramValue: undefined,
        unit: "小时",
        min: 1,
        max: 20000,
        remark: "每隔多少小时无纺布电机转动一次"
      },{
        address: 18,
        paramName: "无纺布可换次数",
        paramValue: undefined,
        unit: "次",
        min: 1,
        max: 10000,
        remark: "每卷无纺布可更换次数"
      },{
        address: 19,
        paramName: "无纺布更换倒计时",
        paramValue: undefined,
        unit: "小时",
        min: 1,
        max: 10000,
        remark: "无纺布下次更换倒计时"
      },{
        address: 20,
        paramName: "无纺布剩余更换次数",
        paramValue: undefined,
        unit: "次",
        min: 1,
        max: 10000,
        remark: "无纺布剩余可更换次数"
      },{
        address: 21,
        paramName: "无纺布剩余更换天数",
        paramValue: undefined,
        unit: "天",
        min: 1,
        max: 10000,
        remark: "无纺布剩余更换天数"
      },{
        address: 24,
        paramName: "定时上传时间",
        paramValue: undefined,
        unit: "秒",
        min: 5,
        max: 300,
        remark: "定时上传设备状态的时间间隔"
      },{
        address: 26,
        paramName: "强制关机持续时间",
        paramValue: undefined,
        unit: "分钟",
        min: 10,
        max: 300,
        remark: "新风发送关机指令后的恢复开机时间"
      }]
    }
  },
  created() {
    this.listenSocket();
  },
  beforeDestroy() {
    if(this.socket != null) {
      this.socket.close();
    }
  },
  methods: {
    close(){
      this.$emit("close");
    },
    readParams(){
      this.postForm("/device/readParam",{
        deviceCode: this.deviceCode
      }, true);
    },
    //设置单个参数
    setParam(address, value){
      this.loading = true;
      this.postForm("/device/setParam",{
        deviceCode: this.deviceCode,
        address: address,
        value: value
      }, true).finally(()=>{
        this.loading = false;
      });
    },
    setParams(){

    },
    listenSocket(){
      this.socket = new WebSocket(this.globalConfig.wsRoot+"/settings-push/"+this.deviceCode);
      this.socket.onmessage = (e)=>{
        let bean = JSON.parse(e.data);
        this.records.forEach(item => {
          item.paramValue = bean["v"+item.address];
        });
      }
      this.socket.onclose = () => {
        console.log("socket is closed");
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>